import { CREDIT_CIBIL_LOADING, CREDIT_CIBIL_SUCCESS, CREDIT_CIBIL_FAILED, SEND_OTP_CIBIL_LOADING, SEND_OTP_CIBIL_SUCCESS, SEND_OTP_CIBIL_FAILED,VALIDATE_OTP_LOADING,
  VALIDATE_OTP_SUCCESS,
  VALIDATE_OTP_FAILED, SAVE_CIBIL_LOADING,
  SAVE_CIBIL_SUCCESS, SAVE_CIBIL_FAILED, SAVE_ALTERNATE_MOBILE_LOADING,
  SAVE_ALTERNATE_MOBILE_SUCCESS, SAVE_ALTERNATE_MOBILE_FAILED,
  SAVE_SKIP_LOADING, SAVE_SKIP_SUCCESS, SAVE_SKIP_FAILED,
  VERIFY_ANSWERS_LOADING, VERIFY_ANSWERS_SUCCESS, VERIFY_ANSWERS_FAILED
   } from '../Constants/creditCibilHistoryConstants';


export const creditCibilReducer = (
    state = { creditCibilData: [] },
    action
) => {
    switch (action.type) {
        case CREDIT_CIBIL_LOADING:
            return { loading: true, creditCibilData: [] };
        case CREDIT_CIBIL_SUCCESS:
            return { loading: false, creditCibilData: action.payload };
        case CREDIT_CIBIL_FAILED:
            return { loading: false, error: action.creditCibilData };
        default:
            return state;
    }
};

export const sendOtpCreditCibilReducer = (
  state = { sendOtpCreditCibilData: [] },
  action
) => {
  switch (action.type) {
    case SEND_OTP_CIBIL_LOADING:
      return { loading: true, sendOtpCreditCibilData: [] };
    case SEND_OTP_CIBIL_SUCCESS:
      return { loading: false, sendOtpCreditCibilData: action.payload };
    case SEND_OTP_CIBIL_FAILED:
      return { loading: false, error: action.sendOtpCreditCibilData };
    default:
      return state;
  }
}

export const otpMatchCibilReducer = (
  state = { otpMatchCibilData: [] },
  action
) => {
  switch (action.type) {
    case VALIDATE_OTP_LOADING:
      return { loading: true, otpMatchCibilData: [] };
    case VALIDATE_OTP_SUCCESS:
      return { loading: false, otpMatchCibilData: action.payload };
    case VALIDATE_OTP_FAILED:
      return { loading: false, error: action.otpMatchCibilData };
    default:
      return state;
  }
}

export const saveCibilReducer = (
  state = { saveCibilData: [] },
  action
) => {
  switch (action.type) {
    case SAVE_CIBIL_LOADING:
      return { loading: true, saveCibilData: [] };
    case SAVE_CIBIL_SUCCESS:
      return { loading: false, saveCibilData: action.payload };
    case SAVE_CIBIL_FAILED:
      return { loading: false, error: action.saveCibilData };
    default:
      return state;
  }
}

export const saveAlternateMobileReducer = (
  state = { saveAlternateMobileData: [] },
  action
) => {
  switch (action.type) {
    case SAVE_ALTERNATE_MOBILE_LOADING:
      return { loading: true, saveAlternateMobileData: [] };
    case SAVE_ALTERNATE_MOBILE_SUCCESS:
      return { loading: false, saveAlternateMobileData: action.payload };
    case SAVE_ALTERNATE_MOBILE_FAILED:
      return { loading: false, error: action.saveAlternateMobileData };
    default:
      return state;
  }
}

export const saveSkipStepReducer = (
  state = { saveSkipStepData: [] },
  action
) => {
  switch (action.type) {
    case SAVE_SKIP_LOADING:
      return { loading: true, saveSkipStepData: [] };
    case SAVE_SKIP_SUCCESS:
      return { loading: false, saveSkipStepData: action.payload };
    case SAVE_SKIP_FAILED:
      return { loading: false, error: action.saveSkipStepData };
    default:
      return state;
  }
}

export const verifyAnswersReducer = (
  state = { verifyAnswersData: [] },
  action
) => {
  switch (action.type) {
    case VERIFY_ANSWERS_LOADING:
      return { loading: true, verifyAnswersData: [] };
    case VERIFY_ANSWERS_SUCCESS:
      return { loading: false, verifyAnswersData: action.payload };
    case VERIFY_ANSWERS_FAILED:
      return { loading: false, error: action.verifyAnswersData };
    default:
      return state;
  }
}